import { render, staticRenderFns } from "./itemsPerPage.vue?vue&type=template&id=72eda85a&scoped=true&"
import script from "./itemsPerPage.vue?vue&type=script&lang=js&"
export * from "./itemsPerPage.vue?vue&type=script&lang=js&"
import style0 from "./itemsPerPage.vue?vue&type=style&index=0&id=72eda85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eda85a",
  null
  
)

export default component.exports